import { render, staticRenderFns } from "./TsCurrencyConverterInput.vue?vue&type=template&id=227cdc5a&"
import script from "./TsCurrencyConverterInput.vue?vue&type=script&lang=js&"
export * from "./TsCurrencyConverterInput.vue?vue&type=script&lang=js&"
import style0 from "./TsCurrencyConverterInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports